<span class="dialog-title">
	<mat-icon aria-hidden="true">filter_alt</mat-icon>
	<h2 mat-dialog-title>Suchfilter</h2>
</span>

<hr/>

<mat-dialog-content class="dialog-content">
	<ng-container
		*ngTemplateOutlet="filterGroup; context: { groupKey: 'searchFields', title: 'Suchfelder', chips: searchFieldChips }">
	</ng-container>
	<ng-container
		*ngTemplateOutlet="filterGroup; context: { groupKey: 'status', title: 'Verfahrenstatus', chips: statusFilterChips }">
	</ng-container>
</mat-dialog-content>

<ng-template #filterGroup let-groupKey="groupKey" let-title="title" let-chips="chips">
	<div>
		<span class="filter-group-header">
			<span [id]="'filter-group-label-' + groupKey">{{ title }}</span>
			<button mat-button disableRipple="true" [attr.data-test-id]="'toggle-all-' + groupKey"
			        (click)="toggleAll(groupKey)">{{ toggleAllLabel(groupKey) }}</button>
		</span>
		<div class="chip-list"
		     role="group"
		     [attr.aria-labelledby]="'filter-group-label-' + groupKey"
		     [attr.aria-describedby]="'filter-error-' + groupKey"
		     [attr.aria-invalid]="noneSelected(groupKey)">
			@for (chip of chips; track chip.value) {
				@if(forceNewLineBefore(chip.value)) {
					<div class="chip-line-break"></div>
				}
				<div class="chip"
				     [class.chip--selected]="isSelected(groupKey, chip)"
				     role="button"
				     tabindex="0"
				     [attr.aria-pressed]="isSelected(groupKey, chip)"
				     [attr.data-test-id]="groupKey + '-' + chip.value + '-chip'"
				     (click)="toggleFilter(groupKey, chip)"
				     (keydown.enter)="toggleFilter(groupKey, chip)"
				     (keydown.space)="toggleFilter(groupKey, chip); $event.preventDefault()">
					@if (isSelected(groupKey, chip)) {
						<mat-icon class="chip-icon" aria-hidden="true">check</mat-icon>
					} @else {
						<mat-icon class="chip-icon" aria-hidden="true">clear</mat-icon>
					}
					<span class="chip-label">{{ chip.label }}</span>
				</div>
			}
		</div>
		<p class="filter-error-message"
		   [id]="'filter-error-' + groupKey"
		   [attr.data-test-id]="'filter-error-' + groupKey"
		   [class.filter-error-message--visible]="noneSelected(groupKey)"
		   [attr.aria-live]="noneSelected(groupKey) ? 'polite' : 'off'"
		   [attr.aria-hidden]="!noneSelected(groupKey)">
			<mat-icon class="filter-error-icon" aria-hidden="true">error_outline</mat-icon>
			Bitte wählen Sie mindestens einen Eintrag aus.
		</p>
	</div>
</ng-template>

<hr/>

<mat-dialog-actions class="dialog-actions">
	<button mat-stroked-button data-test-id="cancel-filter-button" (click)="cancel()" (keydown.enter)="cancel()">Abbrechen</button>
	<button class="c-apply-filter-button" mat-flat-button color="primary"
	        [disabled]="hasErrors()" [attr.aria-disabled]="hasErrors()"
	        (click)="applyFilters()" (keydown.enter)="applyFilters()"
	        data-test-id="apply-filter-button"
	>Anwenden</button>
</mat-dialog-actions>



